export var COMPONENT_STATE = /* @__PURE__ */ ((COMPONENT_STATE2) => {
  COMPONENT_STATE2["BASE"] = "base";
  COMPONENT_STATE2["HOVER"] = "hover";
  return COMPONENT_STATE2;
})(COMPONENT_STATE || {});
export var STYLE_ATTRIBUTE = /* @__PURE__ */ ((STYLE_ATTRIBUTE2) => {
  STYLE_ATTRIBUTE2["TEXT"] = "text";
  STYLE_ATTRIBUTE2["BACKGROUND"] = "background";
  STYLE_ATTRIBUTE2["BORDER"] = "border";
  return STYLE_ATTRIBUTE2;
})(STYLE_ATTRIBUTE || {});
export var POPUP_LAYOUT = /* @__PURE__ */ ((POPUP_LAYOUT2) => {
  POPUP_LAYOUT2["FULLSCREEN"] = "fullscreen";
  POPUP_LAYOUT2["MODAL"] = "modal";
  return POPUP_LAYOUT2;
})(POPUP_LAYOUT || {});
export var CLOSE_BUTTON_POSITION = /* @__PURE__ */ ((CLOSE_BUTTON_POSITION2) => {
  CLOSE_BUTTON_POSITION2["LEFT"] = "left";
  CLOSE_BUTTON_POSITION2["RIGHT"] = "right";
  return CLOSE_BUTTON_POSITION2;
})(CLOSE_BUTTON_POSITION || {});
export var CLOSE_BUTTON_SIZE = /* @__PURE__ */ ((CLOSE_BUTTON_SIZE2) => {
  CLOSE_BUTTON_SIZE2["XS"] = "xs";
  CLOSE_BUTTON_SIZE2["SM"] = "sm";
  CLOSE_BUTTON_SIZE2["MD"] = "md";
  CLOSE_BUTTON_SIZE2["LG"] = "lg";
  return CLOSE_BUTTON_SIZE2;
})(CLOSE_BUTTON_SIZE || {});
export var MODAL_TYPE = /* @__PURE__ */ ((MODAL_TYPE2) => {
  MODAL_TYPE2["POPUP"] = "popup";
  MODAL_TYPE2["TEASER"] = "teaser";
  return MODAL_TYPE2;
})(MODAL_TYPE || {});
